import { useState } from "react";
import RecepiconIcon from "../../../../assets/images/generico/RecepcionIcon";
import SalirIcon from "../../../../assets/images/generico/SalirIcon";
import SalirIconDrop from "../../../../assets/images/generico/SalirIconDrop";
import {
  ContainerModalAutoT,
  ModalBodyAutoT,
  ModalTopAutoT,
} from "./localStyle";

const TurnoSinRecepcion = ({
  title,
  desc,
  textBtnOne,
  textBtnTwo,
  handleClick,
}) => {
  const [active, setActive] = useState(true);

  const handleCerrar = () => {
    // setActive(false);
    // alert("pepe")
  };

  return (
    <ContainerModalAutoT $active={active}>
      <div
        className="backgorund-containerModalAutoT"
        onClick={handleCerrar}
      ></div>
      <ModalTopAutoT>
        {/* <RecepiconIcon /> */}
        <h1>{title}</h1>
      </ModalTopAutoT>
      <ModalBodyAutoT>
        <div dangerouslySetInnerHTML={{ __html: desc }} className={"desc"} />
        <div className="container-btn">
          <button onClick={handleClick.btnTwoClick}>
            <SalirIconDrop color={"var(--color-white)"} /> {textBtnTwo}
          </button>
          <button className="bgc-danger" onClick={handleClick.btnOneClick}>
            {textBtnOne}
          </button>
        </div>
      </ModalBodyAutoT>
    </ContainerModalAutoT>
  );
};

export default TurnoSinRecepcion;
